// @mui
import {
  Stack,
  Grid,
  Button,
  Typography,
  Pagination,
  LinearProgress,
} from '@mui/material';
// hooks
import { useEffect, useState } from 'react';
import TrackCard from './TrackCard';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import { UserTableToolbar } from 'src/sections/@dashboard/user/list';
import ConfirmationDialog from '../../shared/ConfirmationDialog';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { TrackModal } from './TrackModal';
import { useTracks } from '../useTracks';
import { Track } from 'src/@types/tracks';

// ----------------------------------------------------------------------
const Sort_Options = ['all', 'acs', 'desc'];

// ----------------------------------------------------------------------

export default function TrackList() {
  const {
    modalOpen,
    setModalOpen,
    filterName,
    filterRole,
    currentTrack,
    setCurrentTrack,
    filteredData,
    page,
    setPage,
    total,
    pageSize,
    loading,
    handleDeleteRow,
    handleEditRow,
    handleFilterName,
    getTrackList,
  } = useTracks();

  // client-side-pagination-list-pages: refetch on page/search change (search
  // debounced 350ms; page changes immediate).
  useEffect(() => {
    const t = setTimeout(() => getTrackList().catch(console.error), filterName ? 350 : 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filterName]);

  const [confirmOpen, setConfirmOpen] = useState({ open: false, currentId: '' });

  return (
    <Stack>
      <HeaderBreadcrumbs
        heading="Track List"
        links={[
          { name: 'Dashboard', href: PATH_DASHBOARD.root },
          { name: 'Track List', href: PATH_DASHBOARD.tracks },
        ]}
        action={
          <Button
            variant="contained"
            onClick={() => setModalOpen(true)}
            startIcon={<Iconify icon={'eva:plus-fill'} />}
          >
            New Track
          </Button>
        }
      />
      <UserTableToolbar
        small={true}
        placeholder="Search Track..."
        filterName={filterName}
        filterRole={filterRole}
        onFilterName={handleFilterName}
        onFilterRole={() => {}}
        optionsRole={Sort_Options}
      />
      {loading && <LinearProgress sx={{ my: 1 }} />}
      <Grid container>
        {filteredData.map((track: Track, index: number) => (
          <Grid
            spacing={1}
            key={track._id}
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            rowSpacing={1}
            columnSpacing={1}
          >
            <TrackCard
              track={track}
              key={index}
              handleEditRow={() => handleEditRow(track)}
              handleDeleteRow={() => {
                setConfirmOpen({ open: true, currentId: track._id });
              }}
            />
          </Grid>
        ))}
        {!loading && filteredData.length === 0 && (
          <Stack width={'100%'} height="300px" alignItems={'center'} justifyContent="center">
            <Typography> No result for your search data</Typography>
          </Stack>
        )}
      </Grid>
      {total > pageSize && (
        <Stack alignItems="center" sx={{ my: 3 }}>
          <Pagination
            count={Math.ceil(total / pageSize)}
            page={page}
            onChange={(_e, p) => setPage(p)}
            color="primary"
          />
        </Stack>
      )}
      <TrackModal
        open={modalOpen}
        handleClose={() => {
          setModalOpen(false);
          getTrackList();
          setCurrentTrack(undefined);
        }}
        isEdit={currentTrack ? true : false}
        currentTrack={currentTrack}
      />
      <ConfirmationDialog
        headText={'Delete Track'}
        text={'Are You Sure You Need To Delete This Track'}
        isOpen={confirmOpen.open}
        onClose={() => {
          setConfirmOpen({ open: false, currentId: '' });
          getTrackList();
        }}
        confirmAction={() => {
          handleDeleteRow(confirmOpen.currentId);
        }}
        loading={false}
      />
    </Stack>
  );
}
